export default "__VITE_ASSET__CLf4LJEV__"